import { config } from '../../utils/config'

export type ReportingSelectionStore = {
  storeId: string
  storeName: string
  humpClubStoreCode: string
  region?: string
}

export async function getReportingSelectionStores(
  token: string | null | undefined,
  params: { region?: string; hotelGroupName?: string; storeRepId?: string },
): Promise<ReportingSelectionStore[]> {
  const url = new URL(`${config.publicRuntimeConfig.humpclubRoot}/reporting/v2/selection-stores`)

  if (params.region) {
    url.searchParams.set('region', params.region)
  }
  if (params.hotelGroupName) {
    url.searchParams.set('hotelGroupName', params.hotelGroupName)
  }
  if (params.storeRepId) {
    url.searchParams.set('storeRepId', params.storeRepId)
  }

  const response = await fetch(url.toString(), {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  })

  if (!response.ok) {
    throw new Error(`Selection stores request failed (${response.status})`)
  }

  return response.json()
}
